import { avatarAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseStyle = definePartsStyle({
  badge: {
    bg: 'white',
    borderWidth: '1px',
    borderColor: 'brand.100',
    boxSize: '1.25em',
  },
  container: {
    color: 'brand.500',
    borderRadius: 'full',
    backgroundColor: 'brand.50',
    border: '1',
    borderColor: 'brand.100',
  },
});

const md = defineStyle({
  width: '40px',
  height: '40px',
  fontSize: 'sm',
});
const lg = defineStyle({
  width: '60px',
  height: '60px',
  fontSize: 'md',
});
const xl = defineStyle({
  width: '80px',
  height: '80px',
  fontSize: 'lg',
});

const sizes = {
  md: definePartsStyle({ container: md }),
  lg: definePartsStyle({ container: lg }),
  xl: definePartsStyle({ container: xl }),
};

export const avatarTheme = defineMultiStyleConfig({ sizes, baseStyle });
